function Honest() {
  return (
    <section className="relative overflow-x-hidden flex flex-row items-center justify-between p-6 lg:p-24">
      <img
        className="absolute w-full h-full object-cover z-10 top-0 left-0"
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/about-honest.png"
        alt="Uczciwość i staranówość - Drzewus - firma godna zaufania"
      />
      <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
      <div className="flex flex-col items-start justify-center gap-2 z-30">
        <h3 className="text-3xl lg:text-5xl text-white">
          Uczciwość i staranność
        </h3>
        <p className="text-white text-left max-w-[800px]">
          W ramach naszych usług możesz liczyć na najwyższą jakość ich
          wykonania, uczciwość i staranność. Najwyższy poziom realizacji
          powierzonych nam zadań, atmosfera przyjaznej współpracy i dbałość o
          każdy aspekt Twojego ogrodu pozwala nam zaoferować to, co najlepsze
          dla Twojej przestrzeni. Jesteśmy entuzjastami tworzenia przestrzeni
          zielonych, kochamy naszą pracę i chcemy dzielić się swoją wiedzą i
          pasją z naszymi klientami. Jesteśmy przekonani, że powierzenie nam
          Twojego ogrodu, będzie najlepszą decyzją, a efekty zachwycą i będą
          spełnieniem marzeń o wyśnionym miejscu wokół domu, na przestrzeniach
          Twojej firmy, na miejskich terenach zielonych i wielu innych.
        </p>
      </div>
    </section>
  );
}

export default Honest;
